export const IconName = {
  ADD_CIRCLE: 'add-circle',
  CLOSE: 'close',
  DELETE: 'delete',
  DOTS_VERTICAL: 'dots-vertical',
  ELLIPSIS: 'ellipsis',
  CHEVRON_LEFT: 'chevron-left',
  CHEVRON_RIGHT: 'chevron-right',
  PLUS: 'plus',
  MINUS: 'minus',
  EYE: 'eye',
  DOCUMENT_DOWNLOAD: 'document-download',
  FILE_PDF: 'file-pdf',
  FILE_IMAGE: 'file-image',
  FILE_VIDEO: 'file-video',
  FILE_AUDIO: 'file-audio',
  FILE_PRESENTATION: 'file-presentation',
  FILE_DOCUMENT: 'file-document',
  ARROW_LEFT_CIRCLE: 'arrow-left-circle',
  ARROW_RIGHT_CIRCLE: 'arrow-right-circle',
  BRIEFCASE: 'briefcase',
  CARET_DOWN: 'caret-down',
  CHECK: 'check',
  CHEVRON_DOWN: 'chevron-down',
  CHEVRON_UP: 'chevron-up',
  CHEVRON_DOUBLE_DOWN: 'chevron-double-down',
  CHEVRON_DOUBLE_UP: 'chevron-double-up',
  CLOUD: 'cloud',
  COPY: 'copy',
  DASHBOARD: 'dashboard',
  DOCUMENT_COPY: 'document-copy',
  DOWNLOAD: 'download',
  EDIT: 'edit',
  ELEMENT_PLUS: 'element-plus',
  EXPORT: 'export',
  EYE_SLASH: 'eye-slash',
  FILTER: 'filter',
  FILTER_DESC: 'filter-desc',
  MENU: 'menu',
  REFRESH: 'refresh',
  SEND: 'send',
  SETTINGS: 'settings',
  LINK: 'link',
  MAIL: 'mail',
  PEOPLE: 'people',
  STAR: 'star',
  PROFILE_ADD: 'profile-add',
  PROFILE_TIMER: 'profile-timer',
  CHECKBOX_OUTLINE: 'checkbox-outline',
  CHECKBOX_CHECKED: 'checkbox-checked',
  CHECKBOX_INDETERMINATE: 'checkbox-indeterminate',
  INFO_CIRCLE: 'info-circle',
  CHECK_CIRCLE: 'check-circle',
  WARNING: 'warning',
  ERROR_CIRCLE: 'error-circle',
  ARROW_RIGHT_SQUARE: 'arrow-right-square',
  ARTICLE: 'article',
  ASSESSMENT: 'assessment',
  AWARD: 'award',
  BAG: 'bag',
  BRIEFCASE_ADD: 'briefcase-add',
  BUBBLE_ALERT: 'bubble-alert',
  BUILDING: 'building',
  CALENDAR: 'calendar',
  CARD: 'card',
  CLOCK: 'clock',
  CLOSE_CIRCLE: 'close-circle',
  CONTENT_FILES: 'content-files',
  CONTENT_RESOURCE: 'content-resource',
  CONTENT_SOCIALS: 'content-socials',
  CUP: 'cup',
  DEVICE_MESSAGE: 'device-message',
  DOCUMENT_TEXT: 'document-text',
  DRAG: 'drag',
  EXPAND: 'expand',
  FLAG_OUTLINE: 'flag-outline',
  GALLERY: 'gallery',
  GALLERY_ADD: 'gallery-add',
  GALLERY_SLASH: 'gallery-slash',
  GIFT: 'gift',
  HAND_BELL: 'hand-bell',
  IMAGE: 'image',
  INFO_FILLED: 'info-filled',
  KEYBOARD_OPEN: 'keyboard-open',
  LEARNING: 'learning',
  LOCK: 'lock',
  LOGOUT: 'logout',
  MONEY: 'money',
  NOTIFICATION: 'notification',
  OPEN: 'open',
  PAUSE: 'pause',
  PEOPLE_GROUP: 'people-group',
  PLANNING: 'planning',
  PLAY: 'play',
  PROFILE: 'profile',
  PROFILE_CIRCLE: 'profile-circle',
  PROMOTE: 'promote',
  SEARCH: 'search',
  SEND_HORIZONTAL: 'send-horizontal',
  SPARKLE: 'sparkle',
  STORE: 'store',
  TEXT_ALIGN_CENTER: 'text-align-center',
  TEXT_ALIGN_JUSTIFY: 'text-align-justify',
  TEXT_ALIGN_LEFT: 'text-align-left',
  TEXT_ALIGN_RIGHT: 'text-align-right',
  TEXT_BOLD: 'text-bold',
  TEXT_BULLET_LIST: 'text-bullet-list',
  TEXT_ITALIC: 'text-italic',
  TEXT_ORDERED_LIST: 'text-ordered-list',
  TEXT_QUOTE: 'text-quote',
  TEXT_UNDERLINE: 'text-underline',
  VIDEO: 'video',
  VIDEO_PLAY: 'video-play',
  VOLUME: 'volume',
  VOLUME_MUTE: 'volume-mute',
  WARNING_HEXAGON: 'warning-hexagon',
  CALL: 'call',
  CIRCLE_SLASH: 'circle-slash',
  FOLDER: 'folder',
  GLOBAL: 'global',
  LIKE: 'like',
  STAR_LEARN: 'star-learn',
  TREND_UP: 'trend-up',
  USER_CHECKED: 'user-checked',
  SKIP_BACK_15: 'skip-back-15',
  SKIP_FORWARD_15: 'skip-forward-15',
  SOCIAL_FACEBOOK: 'social-facebook',
  SOCIAL_INSTAGRAM: 'social-instagram',
  SOCIAL_TIKTOK: 'social-tiktok',
} as const;
export type IconName = (typeof IconName)[keyof typeof IconName];

// Sizes replicating the Icon component's Size variant in Figma. The px value
// for each is mapped in icon.vue.
export const IconSize = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  '2XL': '2xl',
  '3XL': '3xl',
  '4XL': '4xl',
} as const;
export type IconSize = (typeof IconSize)[keyof typeof IconSize];

// Pixel dimensions per size. XS–XL replicate the Figma Icon Size variant
// (12/16/20/24/28); 2XL–4XL cover large decorative icons.
export const iconSizePx: Record<IconSize, number> = {
  [IconSize.XS]: 12,
  [IconSize.SM]: 16,
  [IconSize.MD]: 20,
  [IconSize.LG]: 24,
  [IconSize.XL]: 28,
  [IconSize['2XL']]: 32,
  [IconSize['3XL']]: 40,
  [IconSize['4XL']]: 48,
};
